var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleMouseWheel),expression:"handleMouseWheel"}],ref:"container",staticClass:"merge scroll",on:{"scroll":_vm.handleScroll}},[_c('news'),_c('community',{attrs:{"rows":_vm.rows,"total":_vm.total}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }